import React, {useEffect} from "react";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Table from "../../../components/Table";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PartnerItem from "./PartnerItem";
import {LIST_PARTNERS, ON_PARTNER_UPDATED} from "../../../queries/partners";

const tableHeader = List(["Name", "Role", "Contact", "Addresses", "Status"]);

const PartnersList = (props) => {
  const {loading, error, partners, subscribeToMore, refetch} = props.data;

  useEffect(() => {
    // Refetch the list whenever any partner is added or changed.
    return subscribeToMore({
      document: ON_PARTNER_UPDATED,
      updateQuery: (prev) => {
        refetch();
        return prev;
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Loading />
  if (error) return <GraphQLErrors error={error} />

  return (
    <Table
      data={fromJS(partners || [])}
      renderer={PartnerItem}
      onItemClick={(itemData) => props.onSelectionChange(itemData.get("partnerId"))}
      tableHeader={tableHeader}
      extraClassName="PartnersList"
      itemKey="partnerId"
      mode="table"
      showCount={true}
      selected={props.selectedId}
      />
  );
}

export default graphql(LIST_PARTNERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {role: props.roleFilter || null}
  })
})(PartnersList);
